/**
 * Shared base URL for LeoKit aggregator endpoints (quote, deposit,
 * status, balances). Defaults to the dev proxy at `/api/leokit` — the
 * Vite config and the prod nginx site both rewrite that path onto
 * `api.leokit.dev/*` while injecting the `Api-Key` header server-side,
 * so the key never lands in the built bundle.
 *
 * Override via `VITE_LEOKIT_BASE_URL` for tests / staging.
 */
export const LEOKIT_BASE =
  (import.meta.env.VITE_LEOKIT_BASE_URL as string | undefined) ?? "/api/leokit";
